export default "__VITE_ASSET__qIZGlrVr__"